import { dew as _async2Dew } from "./async";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.once = once;
  var _async = _async2Dew();
  function once(fn) {
    let result;
    let resultP;
    return function* () {
      if (result) return result;
      if (!(yield* (0, _async.isAsync)())) return result = yield* fn();
      if (resultP) return yield* (0, _async.waitFor)(resultP);
      let resolve, reject;
      resultP = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
      });
      try {
        result = yield* fn();
        resultP = null;
        resolve(result);
        return result;
      } catch (error) {
        reject(error);
        throw error;
      }
    };
  }
  0 && 0;

  //# sourceMappingURL=functional.js.map
  return exports;
}